<!-- src/components/modal/goal-type-modal.vue -->
<template>
  <!-- Add Goal Type -->
  <div
    class="modal fade"
    id="new_goal_type"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog">
      <div class="modal-content dq-modal-content" :key="addKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-indigo">
              <i class="ti ti-target"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Add Goal Type</h4>
              <div class="dq-subtitle">Create a goal type to organize performance goals.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitCreate">
          <div class="modal-body dq-modal-body">
            <div class="dq-info-row">
              <div class="dq-info-pill">
                <i class="ti ti-bulb"></i>
                Keep it short & clear (e.g. “Sales Growth”)
              </div>
              <div class="dq-info-pill">
                <i class="ti ti-shield-check"></i>
                Set status to control visibility
              </div>
            </div>

            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-clipboard-text"></i> Goal Type Details
                </div>
                <div class="dq-card-sub">This will be selectable when creating goals.</div>
              </div>

              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label dq-label">Goal Type <span class="text-danger">*</span></label>
                  <input
                    v-model.trim="form.goal_type"
                    class="form-control dq-input"
                    placeholder="e.g. Sales Growth"
                  />
                  <div class="dq-help">Example: Customer Satisfaction, Productivity, Revenue Growth.</div>
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Description</label>
                  <textarea
                    v-model.trim="form.description"
                    class="form-control dq-input"
                    rows="3"
                    placeholder="Optional short description…"
                  ></textarea>
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Status</label>
                  <vue-select
                    v-model="form.status"
                    :options="['Active', 'Inactive']"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />

                  <div class="mt-2 d-flex flex-wrap gap-2">
                    <span v-if="form.status === 'Active'" class="dq-chip dq-chip-ok">
                      <i class="ti ti-circle-check"></i> Active
                    </span>
                    <span v-else class="dq-chip dq-chip-muted">
                      <i class="ti ti-circle-minus"></i> Inactive
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer dq-modal-footer">
            <button type="button" class="btn dq-btn dq-btn-muted" data-bs-dismiss="modal">
              Cancel
            </button>

            <button type="submit" class="btn btn-primary dq-btn dq-btn-primary" :disabled="addingGoalType">
              <span v-if="addingGoalType" class="spinner-border spinner-border-sm me-1"></span>
              Add Goal Type <i class="ti ti-arrow-right ms-2"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Edit Goal Type -->
  <div
    class="modal fade"
    id="edit_goal_type"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable dq-dialog">
      <div class="modal-content dq-modal-content" :key="editKey">
        <!-- Header -->
        <div class="modal-header dq-modal-header">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-amber">
              <i class="ti ti-edit"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Edit Goal Type</h4>
              <div class="dq-subtitle">Update naming, description, and status.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <form @submit.prevent="submitEdit">
          <div class="modal-body dq-modal-body">
            <div class="dq-card">
              <div class="dq-card-head">
                <div class="dq-card-title">
                  <i class="ti ti-adjustments"></i> Update Details
                </div>
                <div class="dq-card-sub">Changes reflect wherever this goal type is used.</div>
              </div>

              <div class="row g-3">
                <div class="col-12">
                  <label class="form-label dq-label">Goal Type <span class="text-danger">*</span></label>
                  <input
                    v-model.trim="form.goal_type"
                    class="form-control dq-input"
                    placeholder="e.g. Sales Growth"
                  />
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Description</label>
                  <textarea
                    v-model.trim="form.description"
                    class="form-control dq-input"
                    rows="3"
                    placeholder="Optional short description…"
                  ></textarea>
                </div>

                <div class="col-12">
                  <label class="form-label dq-label">Status</label>
                   <vue-select
                    v-model="form.status"
                    :options="['Active', 'Inactive']"
                    placeholder="Select Status"
                    class="dq-vselect"
                    :clearable="false"
                  />

                  <div class="mt-2 d-flex flex-wrap gap-2">
                    <span v-if="form.status === 'Active'" class="dq-chip dq-chip-ok">
                      <i class="ti ti-circle-check"></i> Active
                    </span>
                    <span v-else class="dq-chip dq-chip-muted">
                      <i class="ti ti-circle-minus"></i> Inactive
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer dq-modal-footer">
            <button type="button" class="btn dq-btn dq-btn-muted" data-bs-dismiss="modal">
              Cancel
            </button>

            <button type="submit" class="btn btn-primary dq-btn dq-btn-primary" :disabled="!isEdit || addingGoalType">
              <span v-if="addingGoalType" class="spinner-border spinner-border-sm me-1"></span>
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-md dq-dialog">
      <div class="modal-content dq-modal-content">
        <div class="modal-header dq-modal-header dq-danger-head">
          <div class="dq-titlewrap">
            <div class="dq-hero dq-hero-red">
              <i class="ti ti-trash"></i>
            </div>
            <div>
              <h4 class="modal-title dq-title mb-0">Confirm Delete</h4>
              <div class="dq-subtitle">This action cannot be undone.</div>
            </div>
          </div>

          <button
            type="button"
            class="btn-close custom-btn-close dq-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body dq-modal-body">
          <div class="dq-danger">
            <i class="ti ti-alert-triangle"></i>
            <div>
              <div class="dq-danger-title">Delete goal type record?</div>
              <div class="dq-danger-sub">
                You’re about to permanently remove this goal type. If it’s used elsewhere, consider setting it to
                <strong>Inactive</strong> instead.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer dq-modal-footer">
          <button type="button" class="btn dq-btn dq-btn-muted" data-bs-dismiss="modal">
            Cancel
          </button>

          <button class="btn btn-danger dq-btn dq-btn-danger" :disabled="deleting" @click="confirmDelete">
            <span v-if="deleting" class="spinner-border spinner-border-sm me-1"></span>
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useGoalTypeStore } from "@/stores/goalTypeStore";
import { toast } from "@/utils/toast";

const props = defineProps({
  editItem: { type: Object, default: null },
});
const emit = defineEmits(["saved"]);

const goalTypeStore = useGoalTypeStore();

const deleting = ref(false);
const addingGoalType = computed(() => goalTypeStore.loading);

const addKey = ref(0);
const editKey = ref(0);

const form = ref(blankForm());

function blankForm() {
  return {
    goal_type: "",
    description: "",
    status: "Active",
  };
}

function resetForm() {
  const blank = blankForm();
  for (const k in blank) form.value[k] = blank[k];
}

watch(
  () => props.editItem,
  (val) => {
    if (val) {
      form.value.goal_type = val.goal_type ?? "";
      form.value.description = val.description ?? "";
      form.value.status = val.status ?? "Active";
      editKey.value++;
    } else {
      resetForm();
    }
  },
  { immediate: true }
);

const isEdit = computed(() => !!props.editItem?.id);

async function submitCreate() {
  if (!form.value.goal_type?.trim()) {
    toast("Goal Type is required", "error");
    return;
  }

  const payload = { ...form.value };
  await goalTypeStore.create(payload);

  closeNew();
  resetForm();
  addKey.value++;
  emit("saved");
}

async function submitEdit() {
  if (!props.editItem?.id) return;

  if (!form.value.goal_type?.trim()) {
    toast("Goal Type is required", "error");
    return;
  }

  const payload = { ...form.value };
  await goalTypeStore.update(props.editItem.id, payload);

  closeEdit();
  resetForm();
  editKey.value++;
  emit("saved");
}

function closeNew() {
  document.querySelector('#new_goal_type [data-bs-dismiss="modal"]')?.click();
}
function closeEdit() {
  document.querySelector('#edit_goal_type [data-bs-dismiss="modal"]')?.click();
}

async function confirmDelete() {
  deleting.value = true;
  try {
    if (!props.editItem?.id) return;
    await goalTypeStore.remove(props.editItem.id);
    emit("saved");
  } catch (e) {
    console.error(e);
  } finally {
    deleting.value = false;
  }
}

let cleanup = null;
onMounted(() => {
  const addEl = document.getElementById("new_goal_type");
  const editEl = document.getElementById("edit_goal_type");

  const handleAddShow = () => {
    resetForm();
    addKey.value++;
  };
  const handleAddHidden = () => resetForm();
  const handleEditHidden = () => {
    resetForm();
    editKey.value++;
  };

  addEl?.addEventListener("show.bs.modal", handleAddShow);
  addEl?.addEventListener("hidden.bs.modal", handleAddHidden);
  editEl?.addEventListener("hidden.bs.modal", handleEditHidden);

  cleanup = () => {
    addEl?.removeEventListener("show.bs.modal", handleAddShow);
    addEl?.removeEventListener("hidden.bs.modal", handleAddHidden);
    editEl?.removeEventListener("hidden.bs.modal", handleEditHidden);
  };
});

onBeforeUnmount(() => cleanup && cleanup());
</script>

<style scoped>
.dq-dialog { max-width: 820px; }

/* Shell */
.dq-modal-content{
  border-radius: 22px;
  border: none;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08),
    0 40px 90px rgba(15, 23, 42, 0.14);
}
.dq-modal-header{
  padding: 18px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.10), #fff);
}
.dq-danger-head{
  background: linear-gradient(180deg, rgba(239, 68, 68, 0.12), #fff);
}
.dq-modal-body{ padding: 16px 20px; }

/* Reliable scroll + sticky footer */
.modal-dialog.modal-dialog-scrollable .modal-content{
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}
.modal-dialog.modal-dialog-scrollable .modal-body{
  overflow-y: auto;
  max-height: calc(92vh - 150px);
  overscroll-behavior: contain;
}
.dq-modal-footer{
  padding: 14px 20px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 2;
}

/* Header */
.dq-titlewrap{ display:flex; align-items:center; gap:12px; }
.dq-title{ font-weight: 950; letter-spacing: -0.35px; }
.dq-subtitle{ font-size:.82rem; color: rgba(15, 23, 42, 0.6); }
.dq-close{ opacity:.9; }
.dq-close:hover{ opacity:1; }

/* Hero */
.dq-hero{
  width: 46px; height: 46px; border-radius: 16px;
  display:flex; align-items:center; justify-content:center;
  font-size: 20px;
}
.dq-hero-indigo{ background: rgba(99, 102, 241, 0.14); color: rgb(79, 70, 229); }
.dq-hero-amber{ background: rgba(245, 158, 11, 0.14); color: rgb(217, 119, 6); }
.dq-hero-red{ background: rgba(239, 68, 68, 0.14); color: rgb(220, 38, 38); }

/* Cards */
.dq-card{
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background:#fff;
  padding: 14px;
}
.dq-card-head{ padding: 2px 2px 10px; }
.dq-card-title{
  font-weight: 950;
  display:inline-flex; align-items:center; gap:8px;
}
.dq-card-sub{
  margin-top: 6px;
  font-size:.82rem;
  color: rgba(15, 23, 42, 0.6);
}

/* Tips */
.dq-info-row{ display:flex; gap:10px; flex-wrap:wrap; margin-bottom: 12px; }
.dq-info-pill{
  flex:1 1 260px;
  display:flex; gap:10px; align-items:center;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(15, 23, 42, 0.02);
  color: rgba(15, 23, 42, 0.72);
  font-weight: 800;
  font-size: .82rem;
}
.dq-info-pill i{ color: rgba(99, 102, 241, 0.85); }

/* Inputs */
.dq-label{ font-size:.82rem; font-weight: 900; }
.dq-input{
  border-radius: 14px;
  padding: 10px 12px;
}
.dq-input:focus{
  border-color: rgba(99, 102, 241, 0.35);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.dq-help{
  margin-top: 6px;
  font-size: .8rem;
  color: rgba(15, 23, 42, 0.55);
}

/* Buttons */
.dq-btn{ border-radius: 12px; padding: 10px 16px; font-weight: 900; }
.dq-btn-muted{
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-btn-primary{ box-shadow: 0 12px 24px rgba(15, 23, 42, 0.10); }
.dq-btn-danger{ box-shadow: 0 12px 24px rgba(239, 68, 68, 0.12); }

/* Chips */
.dq-chip{
  display:inline-flex; align-items:center; gap:8px;
  padding: 8px 10px;
  border-radius: 14px;
  font-size: .82rem;
  font-weight: 900;
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.dq-chip-muted{ background: rgba(15, 23, 42, 0.04); color: rgba(15, 23, 42, 0.7); }
.dq-chip-ok{ background: rgba(16, 185, 129, 0.12); color: rgb(5, 150, 105); }

/* Delete warning */
.dq-danger{
  display:flex; gap:12px; align-items:flex-start;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(239, 68, 68, 0.14);
  background: rgba(239, 68, 68, 0.08);
}
.dq-danger i{
  font-size: 18px;
  color: rgb(220, 38, 38);
  margin-top: 2px;
}
.dq-danger-title{ font-weight: 950; }
.dq-danger-sub{ margin-top: 6px; font-size:.82rem; color: rgba(15, 23, 42, 0.7); }

@media (max-width: 576px){
  .dq-dialog{ max-width: 96vw; margin: .75rem auto; }
}
</style>
